import React, { useState, Fragment, useMemo } from 'react'
import { Row, Col } from 'react-flexbox-grid'
import { useTranslation } from 'react-i18next'

import IngredientsTable from '../fragments/IngredientsTable'
import IngredientDetails from '../fragments/IngredientDetails'
import { ListQuery } from 'components/graphql'
import { useMutation } from 'components/graphql'
import { listProducts, listIngredients } from '../../../gql/query'
import { createIngredient } from '../../../gql/mutation'
import { Select } from 'components/forms'
import getNameOfGqlQuery from 'helpers/getNameOfGqlQuery'
import useSafeState from 'hooks/useSafeState'
import styles from '../ingredients.module.scss'

const Ingredients = ({ data = {}, ingredientGroup, updateMutation, selectedLinkProduct: linkProduct, onChangeLinkProduct }) => {
	const [t] = useTranslation()
	const [mutateIngr] = useMutation(createIngredient)
	const emptyIngr = {
		id: null,
		productId: data.id,
		amount: null,
		contains: ingredientGroup === 'allergens_EU' ? true : null,
		ingredient: { group: ingredientGroup, units: null, code: null }
	}
	const [loadingIngredients, setLoadingIngredients] = useSafeState(false)
	const [editingIngr, setEditingIngr] = useState(emptyIngr)
	const ingrsToDisplay = useMemo(() => {
		const isRAConnected = data?.RA_RecipeId
		if(!isRAConnected) {
			return data?.linkProduct ? data?.linkProduct?.ingredients || [] : data?.ingredients
		}
		if(ingredientGroup === 'nutrients') {
			return data?.RA_Recipe?.calculatedVals?.nutrients
		} else if(ingredientGroup === 'allergens_EU') {
			return data?.RA_Recipe?.calculatedVals?.allergens
		}
	}, [data, ingredientGroup])
	const isLinkProductSelected = !!(linkProduct && linkProduct.id)
	const recipeId = data?.RA_RecipeId

	return(
		<Fragment>
			<Select
				isSearchable
				noForm
				paginated
				value={linkProduct}
				simpleValue={false}
				valueField='id'
				labelField='name'
				onChange={async val => {
					setLoadingIngredients(true)
					setEditingIngr(emptyIngr)
					onChangeLinkProduct(val && val.id ? val : null)
					updateMutation({ linkProduct: val && val.id ? val.id : null })
						.then(() => {
							setLoadingIngredients(false)
						})
				}}
				label={t('product_section.fields.product_link')}
				withVirtualBody
				isClearable
				remoteOptions={{ query: listProducts, variables: { params: { limit: 50 } } }}
				isDisabled={!!recipeId} />
			<Row>
				<Col xs={6}>
					<ListQuery query={listIngredients} variables={{ type: ingredientGroup }}>
						{({ data: allIngrs }) => (
							<IngredientsTable
								fetchedIngrs={data.ingredients}
								key={linkProduct ? linkProduct.id : 0}
								product={data}
								allIngrs={allIngrs}
								productIngrs={ingrsToDisplay}
								productId={data.id}
								mutateProduct={updateMutation}
								isIngrsLinked={isLinkProductSelected}
								ingredientGroup={ingredientGroup}
								withSearch
								selectRow={ingredientGroup === 'nutrients'}
								{...ingredientGroup === 'nutrients' && { onRowClick: (state, { original: { id: ingredientId, productIngrId: id, amount, contains } }) =>
									setEditingIngr({ ...emptyIngr, id, ingredientId, amount, contains })
								}}
								onAddIngredient={() => setEditingIngr({ ...emptyIngr, id: -1 })}
								onDelete={() => setEditingIngr(emptyIngr)}
								disabled={isLinkProductSelected || recipeId}
								loading={loadingIngredients}
								height={484} />
						)}
					</ListQuery>
				</Col>
				<Col xs={6} className={styles['form-col']}>
					{!((editingIngr.id || editingIngr.ingredientId) && !linkProduct) ? null :
						<IngredientDetails
							key={editingIngr.ingredientId}
							product={data}
							ingredientGroup={ingredientGroup}
							mutateIngr={mutateIngr}
							mutationIngrName={getNameOfGqlQuery(createIngredient)}
							mutateProduct={updateMutation}
							ingrData={editingIngr}
							productIngrs={ingrsToDisplay}
							closeForm={() => setEditingIngr(emptyIngr)}
						/>
					}
				</Col>
			</Row>
		</Fragment>
	)
}

export default Ingredients
